(function () {
  var redirecting = false;
  function goCheckout() {
    if (redirecting) return;
    redirecting = true;
    window.location.href = '/checkout';
  }
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var u = (typeof url === 'string') ? url : (url && url.url) || '';
    var p = origFetch.apply(this, arguments);
    if (u && u.indexOf('/cart/add') !== -1) {
      p.then(function (res) { if (res && res.ok) { goCheckout(); } }).catch(function () {});
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.evIsAdd = (typeof url === 'string') && url.indexOf('/cart/add') !== -1;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.evIsAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) { goCheckout(); }
      });
    }
    return origSend.apply(this, arguments);
  };
})();